/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderSubtotalsModule
 * Purpose		: Module for OrderSubtotals.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { OrderSubtotalsService } from './OrderSubtotals.service';
import { OrderSubtotalsListComponent } from './OrderSubtotalsList.component';
import { OrderSubtotalsSearchComponent } from './OrderSubtotalsSearch.component';
import { OrderSubtotalsDetailsComponent } from './OrderSubtotalsDetails.component';

import { OrderSubtotalsRoutingModule } from './OrderSubtotals-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    OrderSubtotalsRoutingModule
  ],
  declarations: [
    OrderSubtotalsListComponent,
	OrderSubtotalsSearchComponent,
	OrderSubtotalsDetailsComponent
  ],
  providers: [
    OrderSubtotalsService
  ]
})

export class OrderSubtotalsModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrderSubtotals/OrderSubtotals.module.ts